// extracted by mini-css-extract-plugin
export default {"mainContainer":"ParentingRewards_mainContainer__IL57u","comingSoonImg":"ParentingRewards_comingSoonImg__r5WTU"};